


























import { Component, Mixins } from "vue-property-decorator";
import { HelpFileInformation } from "../../../domain/help";
import { DialogMixin } from "../../system/mixins";

@Component({
  components: {
  },
})
export default class HelpFileSelectDialog extends Mixins(DialogMixin) {
  data() {
    return {
      files: [] as HelpFileInformation[],
      openFile: null as (file: HelpFileInformation) => void,
    };
  }
  files: HelpFileInformation[];
  openFile: (file: HelpFileInformation) => void;

  async show(files: HelpFileInformation[], openFile: (file: HelpFileInformation) => void): Promise<void> {
    this.files = files;
    this.openFile = openFile;
    return this.showModal(async () => {
      await this.waitHidden();
    });
  }

  onSelected(selected: HelpFileInformation): void {
    if (!selected) {
      return;
    }
    this.openFile(selected);
  }

  cancel() {
    this.isVisible = false;
  }
}
